import axios from 'axios'
import {
  headers,
  outputError,
  API_TOKEN,
  updateAPIToken
} from './token';
const BASE_URL = process.env.BASE_URL

export default {
  checkPassword(context, password, cb) {
    axios
      .get(`${BASE_URL}checkcredentials?password=${password}`)
      .then(response => {
        console.log(response)
        cb(response)
      })
      .catch(error => {
        console.log(JSON.stringify(error));
        cb(error);
      });
  },

}


// WEBPACK FOOTER //
// ./src/api/public.js